// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__gcz3m","modal":"Modal_modal__uGROC","slide-down":"Modal_slide-down__wb4hJ","content":"Modal_content__qWgMc","cancel":"Modal_cancel__oXxIh"};